import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class AgentConfigurationProfileSelect implements IController {

  selectedId: any;
  options: any[];
  optionIds: string[];
  isRequired: boolean;
  isDisabled: boolean;
  excludeIds: string[];
  ngPlaceholder: string;
  queryMap: any;
  onChange: Function;

  private profilesRef: any;
  public selectedProfile: any;
  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private $agentConfigurationProfiles, private $element) {
    this.profilesRef = this.$agentConfigurationProfiles();
  }

  $onInit() {
    this._setSelected();
  }

  $onChanges(changes) {
    if ((changes.selectedId && !changes.selectedId.isFirstChange())) {
      this._setSelected();
    }
  }


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdRef = this.selectedId;
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const excludeIdsRef = this.excludeIds;
    const ngPlaceholderRef = this.ngPlaceholder;
    const queryMap = this.queryMap;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'query-map="ctrl.queryMap" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'agentConfigurationProfile';
        this.selectedIdsRef = selectedIdRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.excludeIdsRef = excludeIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.queryMap = queryMap;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedId) => {
        if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
          selectedId = selectedIdRef;
        }

        if (!selectedId) {
          this.onChange({profile: undefined, id: undefined});
          panel.destroy();
        } else {
          if (!!this.options) {
            const profile = _.find(this.options, (o) => {
              return o.id === selectedId;
            })
            this.onChange({profile: profile, id: selectedId});
            panel.destroy();
          } else {
            this.profilesRef.$asyncValues([selectedId])
              .then((profiles) => {
                this.onChange({profile: profiles[0], id: selectedId});
                panel.destroy();
              });
          }
        }
      }
    }

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({profile: undefined});
  }

  private _setSelected() {
    if (!!this.selectedId) {
      if (!!this.options) {
        this.selectedProfile = _.find(this.options, (o) => {
          return o.id === this.selectedId;
        });
        this._setSelectedText();
      } else {
        this.profilesRef.$asyncValues([this.selectedId])
          .then((profiles) => {
            this.selectedProfile = _.orderBy(profiles, ['name'], ['asc'])[0];
            this._setSelectedText()
          });
      }
    } else {
      this.selectedProfile = undefined;
      this._setSelectedText()
    }
  }

  private _setSelectedText() {
    this.selectedText = _.get(this.selectedProfile, 'name', '');
  }
}

angular
  .module('bringoz.admin.configuration-profiles')
  .component('agentConfigurationProfileSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedId: '<',
      options: '<?',
      optionIds: '<?',
      isRequired: '<?',
      isDisabled: '<?',
      excludeIds: '<?',
      agentTypes: '<?',
      queryMap: '<?',
      ngPlaceholder: '@?',
      onChange: '&',
    },
    template: require('./agent-configuration-profile-select.html').default,
    controller: AgentConfigurationProfileSelect
  });
